import { useContext } from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import CustomTabs from '../../../components/common/CustomTabs'
import Title from '../../../components/common/title'
import useSelectedItemSideBar from '../../../hooks/useSelectedItemSideBar'
import AutoFormations from './components/autoFormations'
import MyCertificates from './components/myCertificates'
import NextFormations from './components/nextFormations'
import CustomButton from '../../../components/common/buttons/customButton'
import { ActiveRegionContext } from '../../../context/activeRegionContext'
import LiveHelpIcon from '../../../icons/liveHelpIcon'
import { useMediaQuery } from '@mui/material'

const MyFormations = () => {
  useSelectedItemSideBar('formations.my-formations')
  const { activeRegion } = useContext(ActiveRegionContext)
  const isMobile = useMediaQuery('(max-width:800px)')
  const isSmallMobile = useMediaQuery('(max-width:480px)')
  return (
    <Box sx={{ 
      height: '100%',
      }}>
      <Title>mes formations</Title>
      <Box sx={{ 
      flex: 1,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      paddingBottom: isSmallMobile ? '20px' : isMobile ? '30px' : '40px'
      }}>
          <CustomTabs
            styleTabs={{ 
            mb: isSmallMobile ? '24px' : isMobile ? '32px' : '48px',
            }}
            list={[
              {
                label: 'PROCHAINES FORMATIONS',
                element: <NextFormations />,
                width: isMobile ? 'auto' : '255px',
              },
              {
                label: isMobile ? 'AUTO FORMATIONS' :'AUTOFORMATIONS',
                element: <AutoFormations />,
                width: isMobile ? 'auto' : '255px',
              },
              {
                label: 'MES ATTESTATIONS',
                element: <MyCertificates />,
                width: isMobile ? 'auto' : '255px',
              },
            ]}
          />

          <Box
            sx={{
              border: '1px solid #444D4E',
              p: isSmallMobile ? '20px' : isMobile ? '24px' : '40px',
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: isMobile ? 'flex-start' : 'center',
              mt: isSmallMobile ? '24px' : isMobile ? '32px' : '51px',
              gap: isMobile ? 2 : 0,
            }}
          >
            <LiveHelpIcon />
                <Box
                  sx={{
                    ml: isMobile ? 0 : '5%',
                    mr: isMobile ? 0 : '8%',
                    flex: '1',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: isSmallMobile ? '16px' : '24px',
                    mt: isMobile ? 2 : 0,
                  }}
                >
                    <Typography variant='h3' textTransform='uppercase'>
                      BESOIN D’AIDE ?
                    </Typography>
                    <Typography>
                      Contacter nos experts pour adhérer aux services sur demande et pour toutes questions
                      concernants nos services.
                    </Typography>
                </Box>
                <CustomButton
                  variant='principal'
                  href={`${process.env.REACT_APP_JOIN_US}?regionid=${activeRegion}`}
                  sx={{
                    py: isSmallMobile ? '8px' : '11px',
                    px: isSmallMobile ? '20px' : '30px',
                    fontSize: isSmallMobile ? '13px' : '15px',
                    width: isMobile ? '100%' : 'auto',
                    mt: isMobile ? 1 : 0,
                  }}
                >
                  NOUS JOINDRE
                </CustomButton>
          </Box>
        </Box>
    </Box>
  )
}

export default MyFormations
